import axios from 'axios'
import store from '@/store'
import { forceLogout } from '@/helpers/auth'

// default our apiUrl for tests
import { apiUrl } from '@/plugins/globals.js'

function resolveHostSync(hostOrPromise) {
  if (hostOrPromise && typeof hostOrPromise.then === 'function') {
    throw new Error('[api.js] Host was passed as a Promise! Did you forget to await authUrl()?')
  }
  return hostOrPromise
}

// axios global requests
axios.interceptors.request.use(
  (config) => {
    const token = store.getters['auth/token'];
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.debug('[axios] No token in store – skipping Authorization header');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// axios global response
axios.interceptors.response.use(
  response => response,
  async error => {
    if (apiUrl() !== '') {
      console.debug(`DEBUG => Error Message from interceptor (${apiUrl()}): ${error.message}`, error)
    }

    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      store.getters['auth/token']
    ) {
      console.warn('[api] 401 detected, forcing logout...')
      await forceLogout() // Use the shared function
    }

    return Promise.reject(error)
  }
)

// export axios common base instance (resource: https://goo.gl/sDN0IN)
export default {
  get: (endpoint, config = {}, host = apiUrl()) => {
    return axios.get(`${host}/${endpoint}`, config)
  },

  put: (endpoint, data = {}, config = {}, host = apiUrl()) => {
    return axios.put(`${host}/${endpoint}`, data, config)
  },
  // post: (endpoint, data = {}, config = {}, host = apiUrl()) => {
  //   return axios.post(`${host}/${endpoint}`, data, config)
  // },
  post: (endpoint, data = {}, config = {}, host = apiUrl()) => {
    const resolvedHost = resolveHostSync(host)
    // console.log('DEBUG => [api.js => axios.post()] called with:', {
    //   endpoint,
    //   host,
    //   resolved: typeof host?.then === 'function' ? 'UNRESOLVED PROMISE' : 'ok',
    // })
    if (typeof resolvedHost?.then === 'function') {
      throw new Error('Do not pass an unresolved Promise as base URL')
    }
    return axios.post(`${resolvedHost}/${endpoint}`, data, config)
  },
  delete: (endpoint, data = {}, config = {}, host = apiUrl()) => {
    return axios.delete(`${host}/${endpoint}`, data, config)
  },
  lookupsZeus(key, config = {}) {
    return this.get(`app/GetLookupValues?key=${key}`, config)
  }
}
